import { Source } from "./Source";

export interface PartnerFeeFormula {
    source: Source;
    formula: string;
    type: PartnerFeeFormulaType;
    strategy: PartnerFeeFormulaStrategy;
    max?: number;
    orderAmountIncludesPartnerFee: boolean;
    refundToTraveler: boolean;
    refundToSeller: boolean;
    showConvenienceFeeToSeller: boolean;
}

export enum PartnerFeeFormulaType {
    SELLER = "seller",
    TRAVELER = "traveler",
}

export enum PartnerFeeFormulaStrategy {
    FIXED = "fixed",
    RECALCULATE = "recalculate",
    RECALCULATE_UPWARD = "recalculate_upward",
}
